"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionButtonContainer = void 0;
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const react_1 = __importDefault(require("react"));
const makeMyClasses = height => ({
    root: {
        '& .actionButton': {
            minHeight: height,
            maxHeight: height,
            maxWidth: 46,
            minWidth: 46,
            position: 'relative',
            '& .MuiSvgIcon-root': {
                margin: 'auto',
                width: '1em',
                height: '1em',
                transition: 'width 0.3s, height 0.3s',
            },
            '& .label': {
                maxHeight: 0,
                opacity: 0,
                transition: 'max-height 0.3s, opacity 0.3s',
            },
            '&:hover .MuiSvgIcon-root': {
                width: '0.55em !important',
                height: '0.55em !important',
            },
            '&:hover .label': {
                maxHeight: 16,
                opacity: 1,
            },
        },
        '& .actionButtonBig': {
            minHeight: height,
            maxHeight: height,
            maxWidth: 152,
            minWidth: 46,
        },
    },
});
function ActionButtonContainer(props) {
    const { classes, height = 42 } = props, otherProps = __rest(props, ["classes", "height"]);
    const myCss = (0, web_css_1.default)(makeMyClasses, [height], classes);
    return react_1.default.createElement(Horizontal_1.default, Object.assign({ gutter: true, classes: { root: myCss.root } }, otherProps));
}
exports.ActionButtonContainer = ActionButtonContainer;
exports.default = ActionButtonContainer;
